// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"99dfe49e","276":"bb07881f","290":"9f7a1a3e","537":"949d1a2a","635":"21861528","651":"369821fc","669":"4c7eaa4d","691":"1ed6ce8c","787":"25471cf6","906":"ad8ce120","945":"9e3837f5"}[chunkId] + ".chunk.js";
};